import React from 'react';
import { getMessage } from '@tcc/i18n';
import styles from '../RegionNoteForm.css';
import ConfirmationModal from '../../../../containers/Modal/ConfirmationModal';

type CloseConfirmationModalProps = {
  onCloseModal: () => void;
  onCancelGoBack: () => void;
  handleClickCancel: () => void;
};

export const CloseConfirmationModal = ({
  onCloseModal,
  onCancelGoBack,
  handleClickCancel,
}: CloseConfirmationModalProps) => (
  <div
    className={styles.confirmationModalContainer}
    data-test-id="region-note-form-close-confirmation-modal"
  >
    <ConfirmationModal
      confirmButtonText={getMessage('regions.report.modal.close')}
      handleClickConfirm={() => onCloseModal()}
      handleClickGoBack={() => onCancelGoBack()}
      title={getMessage('regions.report.modal.confirm.close')}
      handleClickCancel={handleClickCancel}
      subTitle={getMessage('regions.report.modal.confirm.close.subheading')}
    />
  </div>
);
